export default class {
  constructor($c) {
    this.catalogBlock = $c.jquery ? $c.get(0) : $c;
    this.sections = this.catalogBlock.querySelectorAll('.js-catalog-section');
    this.subSections = this.catalogBlock.querySelectorAll('.js-catalog-sub-section');

    this.mouseposy = 0;
    this.mouseposx = 0;

    if (this.sections.length) {
      this.sections[0].classList.add('_active');
    }

    if (this.subSections.length) {
      this.subSections[0].classList.add('_active');
    }

    this.addHandlers();
  }

  handlerMenu(e) {
    const sectionHover = e.target.closest('.js-catalog-section');
    if (sectionHover) {
      const section = sectionHover.closest('[data-menu-item-id]');
      const currentId = section.dataset.menuItemId;
      const subSection = this.catalogBlock.querySelector(`[data-submenu-id="${currentId}"]`);

      if (e.type === 'mousemove') {
        if (Math.abs(this.mouseposx - e.screenX) < Math.abs(this.mouseposy - e.screenY)
          || this.mouseposx - e.screenX > 0) {
          this.sections.forEach(item => item.classList.remove('_active'));
          section.classList.add('_active');
          this.subSections.forEach(item => item.classList.remove('_active'));
          subSection.classList.add('_active');
        }

        this.mouseposx = e.screenX;
        this.mouseposy = e.screenY;
      } else {
        this.sections.forEach(item => item.classList.remove('_active'));
        section.classList.add('_active');
        this.subSections.forEach(item => item.classList.remove('_active'));
        subSection.classList.add('_active');
      }
    }
  }

  addHandlers() {
    this.catalogBlock.addEventListener('mousemove', this.handlerMenu.bind(this));
    this.catalogBlock.addEventListener('touchmove', this.handlerMenu.bind(this));
  }
}
